import * as React from "react";
import styled, { css } from "styled-components";

import { breakpoint } from "src/library/utils";

import { Text } from "../Text";

interface IProps {
  copy: React.ReactNode;
  buttons?: React.ReactElement[];
  titleSize?: "small" | "large";
}

const LikeToDoWrapper = styled("div")`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: ${theme.spacing.margins.lg};
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.md};
    border: 1px solid ${theme.colors.lightGrey};
    border-radius: ${theme.borderRadius};

    p {
      margin: 0;
      padding-top: 0;
      padding-right: 0;
    }

    .like-to-do-buttons {
      padding-top: ${theme.spacing.padding.md};

      .like-to-do-button {
        display: block;
        padding-bottom: ${theme.spacing.padding.sm};
        margin-bottom: ${theme.spacing.margins.sm};

        ${breakpoint("md", theme)} {
          display: inline-block;
          margin-right: 20px;
          padding-bottom: 0;
        }
      }
    }
  `}
`;

const LikeToDo: React.ReactFCWithChildren<IProps> = ({
  copy, buttons, titleSize = "small"
}) => {
  return (
    <LikeToDoWrapper className="like-to-do">
      <Text
        className="like-to-do-copy"
        as="p"
        fontSize={titleSize === "large" ? "h1" : "h4"}
        weight={titleSize === "large" ? "bold" : "normal"}
        color={titleSize === "large" ? "primary" : "secondary"}
      >
        {copy}
      </Text>

      {buttons && (
        <div className="like-to-do-buttons">
          {buttons.map((button, i) => {
            if (typeof button === "function") {
              <div
                key={i}
                className="like-to-do-button"
              >
                {button}
              </div>;
            }

            return (
              <div
                key={i}
                className="like-to-do-button"
              >
                {button}
              </div>
            );
          })}
        </div>
      )}
    </LikeToDoWrapper>
  );
};

export default LikeToDo;
